module.exports = __webpack_public_path__ + "img/plus-grey.e8074c1e.svg";